// ============================================================
// Datei: src/pages/deployment/DeploymentMobile.jsx
//
// ÄNDERUNGEN:
// - bestehende Mobile-Tabs bleiben erhalten:
//   1) Meine Schichten
//   2) Verfügbare Schichten
// - in "Verfügbare Schichten" wird neu die 3er-Tab-Komponente angezeigt:
//   Aufbau / Festival / Abbau
// - Festival bleibt dort die Standardansicht
// ============================================================

import React, { useState } from "react";
import AssignedShifts from "../../components/AssignedShifts";
import SalaryInfo from "../../components/SalaryInfo";
import BadgeInfo from "../../components/BadgeInfo";
import DeploymentShiftTabs from "../../components/deploymentShiftTabs/DeploymentShiftTabs";

const TABS = {
	MY_SHIFTS: "MY_SHIFTS",
	AVAILABLE: "AVAILABLE"
};

const DeploymentMobile = ({
	shifts,
	assignedShifts,
	salaryInfo,
	badgeInfo,
	handleJoinShift,
	leaveShift
}) => {

	const [activeTab, setActiveTab] = useState(TABS.MY_SHIFTS);

	const hasNoShifts = assignedShifts.length === 0;

	return (
		<div className="deployment-container bg-reveal">

			<h2 className="deployment-heading">Deployment</h2>

			<div className="mobile-tabs">
				<button
					className={`mobile-tab ${activeTab === TABS.MY_SHIFTS ? "active" : ""}`}
					onClick={() => setActiveTab(TABS.MY_SHIFTS)}
				>
					Meine Schichten
				</button>

				<button
					className={`mobile-tab 
						${activeTab === TABS.AVAILABLE ? "active" : ""}
						${hasNoShifts && activeTab !== TABS.AVAILABLE ? "pulse-green" : ""}
					`}
					onClick={() => setActiveTab(TABS.AVAILABLE)}
				>
					Verfügbare Schichten
				</button>
			</div>

			{activeTab === TABS.MY_SHIFTS && (
				<>
					<AssignedShifts
						shifts={assignedShifts}
						onLeaveShift={leaveShift}
					/>

					<SalaryInfo salary={salaryInfo} />

					<BadgeInfo badges={badgeInfo} />
				</>
			)}

			{activeTab === TABS.AVAILABLE && (
				<DeploymentShiftTabs
					shifts={shifts}
					assignedShifts={assignedShifts}
					handleJoinShift={handleJoinShift}
					isMobile={true}
				/>
			)}
		</div>
	);
};

export default DeploymentMobile;